import './Cart.css';

import { IonContent, IonPage, IonSlide, IonSlides } from '@ionic/react';
import { cardOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from 'react';

import LoadingContainer from '../../components/loading/LoadingContainer';
import NavButtons from '../../components/nav-buttons/NavButtons';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import Axios from '../../library/Axios';
import { DataProvider } from '../../library/DataProvider';
import { CartGetAction, SubmitCartPostAction } from '../../redux/actions/Shop';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import { passToWebView } from '../../library/Funcs';

const Cart: React.FC = () => {
    const maxStep = 2;
    const slideOpts = {
        initialSlide: 0,
        allowTouchMove: false,
        speed: 200
    }

    const dispatch = useAppDispatch()

    const singleCart = useAppSelector(state => state.cartGet)
    const { loading, cart } = singleCart

    const submitCartPost = useAppSelector(state => state.submitCartReducer)
    const { form_loading, resp } = submitCartPost

    const sliderRef = useRef<HTMLIonSlidesElement>(null);

    const [data, setData] = useState({ products: [] as any, provinces: [], summary: {} });

    const [form2, setForm2] = useState({
        full_name: { value: '', validation: { required: true }, error: "" },
        mobile: { value: '', validation: { required: true }, error: "" },
        province: { value: '', validation: { required: true }, error: "" },
        city: { value: '', validation: { required: true }, error: "" },
        address: { value: '', validation: { required: true }, error: "" },
        postal_code: { value: '', validation: {}, error: "" },
        telephone: { value: '', validation: {}, error: "" }
    });

    const [form3, setForm3] = useState({
        coupon_code: { value: '', validation: { required: true }, error: "" },
    });

    const [formProvider2] = useState(() => new DataProvider(form2, setForm2));
    const [formProvider3] = useState(() => new DataProvider(form3, setForm3));

    const form2SubmitHandler = () => {
        let formValidation = formProvider2.validation(form2);

        return formValidation;
    }

    useEffect(() => {
        dispatch(CartGetAction())
    }, [dispatch])

    useEffect(() => {
        if (cart != null && !loading) {
            setData({
                ...data,
                products: cart.items,
                provinces: cart.provinces,
                summary: cart.summary
            });
            
        }
    }, [loading])

    const setCartProducts = (items: any) => {
        setData({ ...data, products: items });
    }

    const setCartSummary = (summary: any) => {
        setData({ ...data, summary: summary });
    }

    const payClickHandler = () => {
        dispatch(SubmitCartPostAction(form2.full_name.value, form2.province.value, form2.city.value, form2.address.value, form2.postal_code.value, form2.telephone.value, form2.mobile.value))
    }

    useEffect(() => {
        if (resp != null && !form_loading) {
            if (resp.result) {
                passToWebView("sendPayment", resp.url);
            }
        }
    }, [form_loading])

    const nextClickHandler = (step: any) => {
        switch (step) {
            case 1:
                if (!form2SubmitHandler()) return false;
                break;
        }

        return true;
    }

    return <LoadingContainer loading={loading}>
        <IonPage className="cart">
            <Toolbar title="سبد خرید" hasBackButton/>

            <LayoutGap />

            <IonContent className="main-content">
                <IonSlides ref={sliderRef} options={slideOpts}>
                    <IonSlide>
                        <Section1 data={data} setCartProducts={setCartProducts} />
                    </IonSlide>
                    <IonSlide>
                        <Section2 formProvider={formProvider2} data={data} />
                    </IonSlide>
                    <IonSlide>
                        <Section3 formProvider={formProvider3} formProvider2={formProvider2} data={data} setCartProducts={setCartProducts} setCartSummary={setCartSummary} />
                    </IonSlide>
                </IonSlides>
            </IonContent>

            {data.products?.length > 0 ?
            <NavButtons slider={sliderRef.current} maxStep={maxStep} finalHas={true} finalLoading={form_loading} finalIcon={cardOutline} finalText="پرداخت" finalClick={payClickHandler} nextClick={nextClickHandler} /> : null}
        </IonPage>
    </LoadingContainer>;
}

export default Cart